import WorkspacesState from './WorkspacesState';
import WorkspacesGetters from './WorkspacesGetters';
import WorkspacesMutations from './WorkspacesMutations';
import WorkspacesActions from './WorkspacesActions';

export default {
    state: WorkspacesState,
    getters: WorkspacesGetters,
    mutations: WorkspacesMutations,
    actions: WorkspacesActions,
};
